<template>
	<div class="container">
		<!--页面开始-->
		<div class="set_box">
			<div class="set_top">
				<div class="set_tit">请设置密码</div>
			</div>
			<van-form>
				<!--密码-->
				<van-field
					v-model="form.pwd"
					name="密码"
					label="密码"
					placeholder="请设置密码"
					:type="pwdType"
					maxlength="16"
					:right-icon="pwdType == 'password' ? 'closed-eye' : 'eye-o'"
					@click-right-icon="rightClick"
					@input="inputChange"
					@focus="inputFouce1"
					@blur="inputFouce2"
				>
					<span :decode="true" slot="label">密&emsp;&emsp;&nbsp;码</span>
				</van-field>
				<!--密码-->
				<!--确认密码-->
				<van-field
					v-model="form.yesPwd"
					name="确认密码"
					label="确认密码"
					placeholder="请再次输入密码"
					:type="pwdType"
					maxlength="16"
					:right-icon="pwdType == 'password' ? 'closed-eye' : 'eye-o'"
					@click-right-icon="rightClick"
				/>
				<!--确认密码-->
				<!--校验规则-->
				<div class="rule_box">
					<div>
						<van-icon v-show="inputType == 1" name="checked" size="0.35rem" />
						<van-icon v-show="inputType == 2" name="warning" size="0.35rem" color="#FF4948" />
						<van-icon v-show="inputType == 3" name="checked" size="0.35rem" color="#4A8BFF" />
						密码由8-16位数字、字母或符号组成
					</div>
				</div>
				<!--校验规则-->
				<div class="btn_box">
					<van-button
						type="info"
						block
						plain
						@click="onSubmit"
						color="#4f56fe"
					>
						<span style="font-size: 0.5rem;">{{ btnText }}</span>
					</van-button>
				</div>
			</van-form>
		</div>
		<!--页面开始-->
	</div>
</template>

<script>
import md5 from 'js-md5';
import { editPwd } from "@/api/login/index";
import { shareUrl } from '@/utils/wxshare'

export default {
	components:{
		//
	},
	data() {
		return {
			form: {
				pwd: '',
				yesPwd: '',
			},
			btnText: '',  //按钮文案
			pwdType: 'password',
			inputType: 1,  //输入内容状态
		}
	},
	created(){
		let that = this;
		if(that.$route.query.type == 2) {
			that.btnText = '确定';
		}else {
			that.btnText = '登录';
		}
	},
	mounted() {
		//微信分享
		let that = this;
		that.$nextTick(() => {
			shareUrl(that);
		});
	},
	watch: {
		//
	},
	methods: {
		//输入框内容变化
		inputChange(value) {
			let that = this;
			if(value.length >= 8) {
				if(!/^[\a-zA-Z\d,\.，?？.<>''"":;{}[\|、】【、‘；“”‘’；：。，）（*&……%￥#@&+-=$！~。]+$/.test(value)) {
					that.inputType = 2;
				}else {
					that.inputType = 3;
				}
			}else {
				if(value != '') {
					if(!/^[\a-zA-Z\d,\.，?？.<>''"":;{}[\|、】【、‘；“”‘’；：。，）（*&……%￥#@&+-=$！~。]+$/.test(value)) {
						that.inputType = 2;
					}else {
						that.inputType = 1;
					}
				}else{
					that.inputType = 1;
				}
			}
		},
		inputFouce1() {
			let that = this;
			that.inputChange(that.form.pwd);
		},
		inputFouce2() {
			let that = this;
			if(that.form.pwd.length < 8) {
				that.inputType = 2;
			}
		},
		//右侧图标点击
		rightClick() {
			let that = this;
			if(that.pwdType == 'password') {
				that.pwdType = 'text';
			}else {
				that.pwdType = 'password';
			}
		},
		//点击登录
		onSubmit() {
			let that = this;
			if(that.form.pwd == "" && that.form.yesPwd == "") {that.$toast('请设置密码');return false;}
			if(that.form.pwd == "" && that.form.yesPwd != "") {that.$toast('请设置密码');return false;}
			if(that.form.pwd != "" && that.form.yesPwd == "") {that.$toast('请确认密码');return false;}
			if(that.form.pwd !== that.form.yesPwd) {that.$toast('两次输入密码不一致，请重新输入');return false;}
			if(that.form.pwd.length && that.form.yesPwd.length < 8) {that.$toast('密码仅支持8-16位大小写字母/数字/标点符号');return false;}
			//if((/.*[\u4e00-\u9fa5]+.*$/.test(that.form.pwd)) && (/.*[\u4e00-\u9fa5]+.*$/.test(that.form.yesPwd))) { that.$toast('密码仅支持8-16位大小写字母/数字/标点符号'); return false; }
			if(!/^[\a-zA-Z\d,\.，?？.<>''"":;{}[\|、】【、‘；“”‘’；：。，）（*&……%￥#@&+-=$！~。]+$/.test(that.form.pwd) && !/^[\a-zA-Z\d,\.，?？.<>''"":;{}[\|、】【、‘；“”‘’；：。，）（*&……%￥#@&+-=$！~。]+$/.test(that.form.yesPwd)) {
				/* that.$toast('密码仅支持8-16位大小写字母/数字/标点符号'); */
				return false;
			}
			//提交密码
			editPwd({password: that.form.pwd, password2: that.form.yesPwd}).then(res => {
				if(that.$route.query.type == 2) {
					that.$toast('操作成功');
					setTimeout(() => {
						//window.history.go(-1);
						localStorage.clear();
						if(that.$route.query.type && that.$route.query.invite) {
							that.$router.push({path:'/login', query: {type: that.$route.query.type, invite: that.$route.query.invite}});
						}else {
							that.$router.push({path:'/login'});
						}
					}, 500);
				}else {
					that.$toast('操作成功');
					setTimeout(() => {
						localStorage.setItem('token', sessionStorage.getItem("token"));
						localStorage.setItem('userPhone', sessionStorage.getItem("userPhone"));
						if(that.$route.query.type && that.$route.query.invite) {
							that.$router.push({path:'/index', query: {type: that.$route.query.type, invite: that.$route.query.invite}});
						}else {
							that.$router.push({path:'/index'});
						}
					}, 500);
				}
			});
		},
	},
	beforeDestroy() {
		clearInterval(this.countDown);
	}
}
</script>
</script>

<style scoped>
>>> .van-field__right-icon .van-icon{
	font-size: 0.5rem;
}
.set_box{
	width: 100%;
	height: 100vh;
	background-color: #F7F7F9;
}
.set_top{
	margin-bottom: 0.5rem;
	padding: 0.8rem 0 0.5rem 0.4rem;
	background-color: #ffffff;
}
.set_top .set_tit{
	font-size: 0.6rem;
	color: #333333;
}
.set_top .set_txt{
	font-size: 0.32rem;
	color: #333333;
}

>>> .send_box .van-button__text{
	color: #bf85ff;
}

>>> .van-cell{
	line-height: 0.8rem;
}
>>> .van-field__label{
	width: 1.8rem;
}

.rule_box div{
	padding: 0.3rem 0 0.4rem 0.35rem;
	color: #999999;
	font-size: 0.32rem;
}
>>> .rule_box .van-icon{
	position: relative;
	top: 2px;
}

.btn_box{
	padding: 0.5rem 1.5rem 0.4rem 1.5rem;
}
.btn_box .van-button{
	height: 1.4rem !important;
	background-color: transparent;
}
.bot_bot{
	position: fixed;
	width: 100%;
	text-align: center;
	left: 0;
	bottom: 0.4rem;
}
.bot_bot  div{
	font-size: 0.38rem;
	color: #666666;
}

.btn_tit{
	text-align: center;
	font-size: 0.38rem;
	color: #999999;
	opacity: 0.5;
}
</style>
